if (!customElements.get('countdown-timer')) {
  class CountdownTimer extends HTMLElement {
    constructor() {
      super();
      this.el = this;
      this.display = this.querySelector('[data-time-display]');
      this.block = this.closest('.countdown__block--timer');
      this.year = this.el.dataset.year;
      this.month = this.el.dataset.month;
      this.day = this.el.dataset.day;
      this.hour = this.el.dataset.hour;
      this.minute = this.el.dataset.minute;
      this.daysPlaceholder = this.querySelector('[date-days-placeholder]');
      this.hoursPlaceholder = this.querySelector('[date-hours-placeholder]');
      this.minutesPlaceholder = this.querySelector('[date-minutes-placeholder]');
      this.secondsPlaceholder = this.querySelector('[date-seconds-placeholder]');
      this.messagePlaceholder = this.querySelector('[data-message-placeholder]');
      this.hideTimerOnComplete = this.el.dataset.hideTimer;
      this.completeMessage = this.el.dataset.completeMessage;
  
      this.timerComplete = false;
  
      this.init();
    }
  
    init() {
      setInterval(() => {
        if (!this.timerComplete) {
          this._calculate();
        }
      }, 1000);
  
    }
  
    _calculate() {
      // Find time difference and convert to integer
      const timeDifference = +new Date(`${this.month}/${this.day}/${this.year} ${this.hour}:${this.minute}:00`).getTime() - +new Date().getTime();
      // If time difference is greater than 0, calculate remaining time
      if (timeDifference > 0) {
        const intervals = {
          days: Math.floor(timeDifference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((timeDifference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((timeDifference / 1000 / 60) % 60),
          seconds: Math.floor((timeDifference / 1000) % 60),
        };
  
        this.daysPlaceholder.innerHTML = intervals.days;
        this.hoursPlaceholder.innerHTML = intervals.hours;
        this.minutesPlaceholder.innerHTML = intervals.minutes;
        this.secondsPlaceholder.innerHTML = intervals.seconds;
      } else {
        if (this.completeMessage && this.messagePlaceholder) {
          this.messagePlaceholder.classList.add('countdown__timer-message--visible');
        }
  
        if (this.hideTimerOnComplete === 'true') {
          this.display.classList.remove('countdown__display--visible');
          this.display.classList.add('countdown__display--hidden');
        }
  
        if (!this.completeMessage && this.hideTimerOnComplete === 'true') {
          this.block.classList.add('countdown__block--hidden');
        }
  
        this.timerComplete = true;
      }
    }
  }

  customElements.define('countdown-timer', CountdownTimer);
}

// Lightweight collapsible/tab trigger (ported from Hartley Sisters theme,
// rewritten without Impulse's internal .on()/.off()/theme.utils dependencies)
(function () {
  function initCollapsibles(scope) {
    var root = scope || document;
    root.querySelectorAll('.collapsible-trigger').forEach(function (trigger) {
      if (trigger.dataset.hsInit) return;
      trigger.dataset.hsInit = 'true';
      trigger.addEventListener('click', function (evt) {
        // Don't double-handle triggers Wealth Kings' own product-page.js
        // already manages via [data-accordion-trigger] — avoids the two
        // handlers fighting each other and closing the panel again.
        if (evt.currentTarget.hasAttribute('data-accordion-trigger')) return;

        var el = evt.currentTarget;
        var isOpen = el.classList.contains('is-open');
        var moduleId = el.getAttribute('aria-controls') || el.dataset.controls;
        if (!moduleId) return;
        var container = document.getElementById(moduleId);
        if (!container) return;

        var inner = container.querySelector('.collapsible-content__inner');
        var innerHeight = inner ? inner.offsetHeight : container.scrollHeight;

        if (isOpen) {
          el.classList.remove('is-open');
          el.setAttribute('aria-expanded', 'false');
          container.style.height = innerHeight + 'px';
          requestAnimationFrame(function () {
            container.classList.remove('is-open');
            container.style.height = '0px';
          });
        } else {
          el.classList.add('is-open');
          el.setAttribute('aria-expanded', 'true');
          container.classList.remove('hide');
          container.classList.add('is-open');
          container.style.height = innerHeight + 'px';
          window.setTimeout(function () {
            if (container.classList.contains('is-open')) {
              container.style.height = 'auto';
            }
          }, 350);
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCollapsibles(document);
  });
  document.addEventListener('shopify:section:load', function (evt) {
    initCollapsibles(evt.target);
  });
})();
